export const openMediaPreview = (file: File | null) => {
  if (file) {
    window.open(URL.createObjectURL(file));
  }
};

export const bytesToMBString = (bytes: number) => {
  return `${bytes / (1024 * 1024)} MB`;
};
